<template>
  

  <v-app id="sales">
    <v-layout>
     
      <div class="vld-parent">
          <!-- <loading :active="isLoading" 
          :can-cancel="false" 
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>         -->
      </div>

      <v-app-bar
        :clipped-left="$vuetify.display.lgAndUp"
        color="green-darken-1"
        dark
        app
        fixed
      >
        <v-app-bar-title style="width: 350px !important" class="ml-0">
          <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
          <!-- <img :src="logo" alt="logo" class="logoSmall" @click="changeRoute('/dashboard')"> -->
          <span class="hidden-sm-and-down">Sales Review </span> <span style="width: 50px !important">{{ ProRights }}</span>
        </v-app-bar-title>
        <v-spacer />
        <v-btn title="logout" variant="text" v-on:click="logout()">
          Logout
          <v-icon>mdi-power</v-icon>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer
        :clipped="$vuetify.display.lgAndUp"
        v-model="drawer"
        fixed
        app
        width="260"
      >
        <v-list density="compact" style="height:auto;" nav >
          <template v-for="item in items">
              <!-- <v-list-group
              v-if="item.children"
              v-model:opened="item.children"
              :key="item.text"
              :prepend-icon="item.icon"
              append-icon
              :class="'ta-menuitem-'+item.title.replaceAll(' ','-').toLowerCase()"            
              >
              <v-list-item v-slot:activator="props">
                <v-list-item-content>
                  <v-list-item-title>{{ item.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                @click="changeRoute(child.route)"
                :class="'ta-submenuitem-'+item.text.replaceAll(' ','-').toLowerCase()+'-'+child.title.replaceAll(' ','-').toLowerCase()"
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ child.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group> -->


          <v-list-group value="Settings"  v-if="item.children" >
              <template v-slot:activator="{ props }">
                <v-list-item
               
                  v-bind="props"
                  prepend-icon="mdi-cog"
                  title="Settings"
                ></v-list-item>
              </template>

              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :title="child.title"               
                :value="child.title"
                @click="changeRoute(child.route)"
               
              ></v-list-item>
          </v-list-group>

              <v-list-item 
                v-else       
                @click="changeRoute(item.route)"
                :class="'ta-menuitem-' + item.title.replaceAll(' ', '-').toLowerCase()"                                
              >                
               
                <template v-slot:prepend>
                  <v-icon 
                  v-bind:class="[
                          { 'text-green': item.title == 'Approved' },
                          { 'text-red': item.title == 'Failed' },
                          { 'text-blue': item.title == 'Dashboard' },
                          { 'text-orange': item.title == 'Pending' },
                          { 'text-purple': item.title == 'Declined' },
                          { 'text-red': item.title == 'Quotes' },
                          { 'text-black': item.title == 'Settings' },
                        ]"
                  :icon="item.icon"></v-icon>
                </template>

                <v-list-item-title 
                  v-bind:class="[
                  { 'text-green': item.title == 'Approved' },
                  { 'text-red': item.title == 'Failed' },
                  { 'text-blue': item.title == 'Dashboard' },
                  { 'text-orange': item.title == 'Pending' },
                  { 'text-purple': item.title == 'Declined' },
                  { 'text-red': item.title == 'Quotes' },
                  { 'text-black': item.title == 'Settings' },
                  ]" v-text="item.title">
                </v-list-item-title>
              </v-list-item >
             
            <!-- <v-layout v-if="item.heading" :key="item.heading" row align-center>
              <v-col col="6">
                <v-list-subheader v-if="item.heading">{{ item.heading }}</v-list-subheader>
              </v-col>
              <v-col col="6" class="text-center">
                <a href="#!" class="text-body-2 text-black">EDIT</a>
              </v-col>
            </v-layout> -->
          
            
            <!-- <v-list-item
              v-else 
              :key="item.title"            
              @click="changeRoute(item.route)"
              :class="'ta-menuitem-' + item.title.replaceAll(' ', '-').toLowerCase()"
            >
              <template v-slot="append"> -->
                <!-- <v-list-item-action >
                
                </v-list-item-action> -->

                <!-- <v-list-item
                    v-bind:class="[
                      { 'text-green': item.title == 'Approved' },
                      { 'text-red': item.title == 'Failed' },
                      { 'text-blue': item.title == 'Dashboard' },
                      { 'text-orange': item.title == 'Pending' },
                      { 'text-purple': item.title == 'Declined' },
                      { 'text-red': item.title == 'Quotes' },
                      { 'text-black': item.title == 'Settings' },
                    ]"
                  >
                  <template v-slot:prepend>
                      <v-icon 
                          v-bind:class="[
                            { 'text-green': item.title == 'Approved' },
                            { 'text-red': item.title == 'Failed' },
                            { 'text-blue': item.title == 'Dashboard' },
                            { 'text-orange': item.title == 'Pending' },
                            { 'text-purple': item.title == 'Declined' },
                            { 'text-red': item.title == 'Quotes' },
                            { 'text-black': item.title == 'Settings' },
                          ]"
                        >{{ item.icon }}</v-icon>
                    </template>
                  
                  {{ item.title }}
                </v-list-item >
              </template>
  

            </v-list-item> -->
          </template>
        </v-list>
      </v-navigation-drawer>

      <v-main class="d-flex" style="min-height: 300px;">
        <v-container fluid fill-height style="padding-left: 2px !important;padding-top: 2px !important;padding-right: 2px !important;">
          <v-layout justify-center>
            <v-col text-xs-center style="padding-left: 2px !important;padding-top: 2px !important;padding-right: 2px !important;">
              <router-view class="view" />
            </v-col>
          </v-layout>
        </v-container>
      </v-main>
     
    </v-layout>
    <v-footer color="green-darken-1" dark fixed style="z-index: 1000 ;position: fixed;bottom: 0;width: 100%;">
        Version : {{ appVersion }} -- {{AgentName}}
        <v-spacer />
        <div class="copyright">
          Greenstone Systems Copyright © 2016-
          {{ new Date().getFullYear() }}, Cultura Technologies, LLC. All Rights
          Reserved Worldwide &nbsp;&nbsp;
        </div>
      </v-footer>
  </v-app>
</template>

<script>
/* eslint-disable */
import foot3 from "@/assets/actionListSmallLogo.svg";
import DataService from "@/services/data-service";
const dataService = new DataService();
import { store } from "@/main";
import { version } from "../../package";
import CryptoService from '@/services/crypto-services';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

const cryptoService = new CryptoService(); 
export default {
  name: "salesReview",
  props: ["AgentId", "SessionID", "TenantId", "UserID"],
  data: () => ({
    appVersion: version,
    AgentName: "",
    ProRights :"",
    isLoading: false,
    logo: foot3,
    open: ['items'],
    admins: [
        ['Management', 'mdi-account-multiple-outline'],
        ['Settings', 'mdi-cog-outline'],
      ],
      cruds: [
        ['Create', 'mdi-plus-outline'],
        ['Read', 'mdi-file-outline'],
        ['Update', 'mdi-update'],
        ['Delete', 'mdi-delete'],
      ],
    items: [
      {
        title: "Dashboard",
        name: "Dashboard",
        icon: "mdi-widgets",
        route: "/dashboard",
        showBadge: false,
        allowAccess: true,
      },
      {
        title: "Pending",
        name: "RequestForChange",
        icon: "mdi-timelapse",
        route: "/bookings/pending",
        showBadge: false,
        allowAccess: true,
      },
      {
        title: "Approved",
        name: "Approved",
        icon: "mdi-check-circle-outline",
        route: "/bookings/approved",
        showBadge: false,
        allowAccess: true,
      },
      {
        title: "Declined",
        name: "declined",
        icon: "mdi-cancel",
        route: "/bookings/declined",
        showBadge: false,
        allowAccess: true,
      },
      {
        title: "Failed",
        name: "failed",
        icon: "mdi-close-box-outline",
        route: "/bookings/failed",
        showBadge: false,
        allowAccess: true,
      },
      {
        title: "Quotes",
        name: "Quotes",
        icon: "mdi-currency-usd",
        route: "/bookings/Quotes",
        showBadge: false,
        allowAccess: true,
      },
      {
        text: "Settings",
        title:"Settings",
        name: "Settings",
        icon: "mdi-cog",
        children: [
          {
            title: "Auto approve",
            name: "AutoApprove",
            icon: "mdi-account-funnel",
            route: "/autoapprove",
            showBadge: false,
            allowAccess: true,
          },
          {
            title: "Order remarks configuration",
            name: "OrderRemarksConfiguration",
            icon: "mdi-account-funnel",
            route: "/salesorderremarksconfiguration",
            showBadge: false,
            allowAccess: true,
          },
          {
            title: "User filter",
            name: "User",
            icon: "account-funnel",
            route: "/settings",
            showBadge: false,
            allowAccess: true,
          },
          {
            title: "Booking Programs",
            name: "bookingPrograms",
            icon: "mdi-account-funnel",
            route: "/bookingPrograms",
            showBadge: false,
            allowAccess: true,
          },
           {
            title: "General Settings",
            name: "CompanyAgreementSendingConfiguration",
            icon: "mdi-account-funnel",
            route: "/CompanyAgreementSendingConfiguration",
            showBadge: false,
            allowAccess: true,
          },
          {
            title: "Date Range",            
            name: "DateRange",
            icon: "mdi-account-funnel",
            route: "/DateRangeConfiguration",
            showBadge: false,
            allowAccess: true,
          },

          
        ],
      },
    ],
    right: null,
    drawer: null,
    show: true,
  }),
  watch: {},
  created() {
    this.initialize();
    this.GetAgentNameForfooter();
    this.getProRights();
  },
  components: {
    Loading,
  },
  methods: {
    initialize() {
      var userInfo = JSON.parse(localStorage.usertData);
      if (userInfo && userInfo.Permissions)
        this.items = this.items.filter((item) => {
          userInfo.Permissions.map((p) => p.Action).includes(item.name);
        });
    },
    GetAgentNameForfooter(){

          var AgentInfo = JSON.parse(localStorage.agentInfo);
          
          dataService.getAllAgentsDescFromAL().then((configs) => {
                this.loading = true;
                this.configs = configs;
                this.configs.forEach((config) => {
                  
                if (config.SOGEAgentId === AgentInfo.AgentId)
                {
                  this.AgentName = config.DisplayName ;
                }
                              
              });
            }).catch((err) => {
                console.log(err);
               // this.error = err;
              });
            ;

          },
    changeRoute: function (routeNum) {
      console.log(routeNum);
      this.$router.replace(routeNum);
    },
    logout: function () {
      this.isLoading = true;
      var userInfo = JSON.parse(localStorage.usertData);
      var agentInfo = JSON.parse(localStorage.agentInfo);
      dataService
        .logout(
          userInfo.userEmail,
          userInfo.Password,
          agentInfo.SessionID,
          agentInfo.TenantId
        )
        .then((success) => {
          console.log(success);
        })
        .catch((err) => {
          console.log(err);
         // this.error = err;
        });
      this.isLoading = false;
      localStorage.removeItem("usertData");
      this.$router.replace("/login");
    },
    getProRights(){
     
      dataService.getSalesProConfigurations(response => {
          console.log("pro->"+ this.ProRights );          
          },
        failure => {}) ;
        
       if (cryptoService.dencryptString(localStorage.getItem("ProUser")) === 'true')
        {
          this.ProRights =  '- pro'  ;
        }
       else 
        { 
        this.ProRights =  '';
        } 

    }
  },
};
</script>
<style>
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
@import url("https://fonts.googleapis.com/css?family=Roboto");

body {
  background: #fff;
  font-family: "Roboto", sans-serif;
}
.v-app-bar-title__content{
  width: 300px !important;
}
.container {
  padding: 0px 0px 50px 0px;
}
.copyright {
  font-size: 0.8em;
}
.page {
  position: fixed;
  width: inherit;
}

.oranged--text {
  color: orangered;
}
.logoSmall {
  width: 23px;
  height: 25px;
  margin-right: 10px;
  margin-left: 15px;
}

.router-anim-enter-active {
  animation: coming 1s;
  animation-delay: 0.5s;
  opacity: 0;
}
.v-list-item theme--light{
  padding: 0px !important;
}
.v-list-item{
  padding: 0px !important;
}
.v-icon.notranslate.material-icons.theme--light::after{
  color: #4083ff !important;
}

.router-anim-leave-active {
  animation: going 1s;
}

.v-list-item--density-compact.v-list-item--one-line {
    min-height: 32px;
}

@keyframes going {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50px);
    opacity: 0;
  }
}
@keyframes coming {
  from {
    transform: translateX(-50px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
